/* bf26z-pdp-gallery.js (R48, 7 Oct 2026) - product page gallery behaviour that does not depend on Shrine main.js. No zoom, no lightbox, no magnifier anywhere.
   A. NATIVE media-gallery PDPs (Gloves, Socks, Bottle, Cap, 2-packs, sets): thumbnails, arrows, keys, swipe and colour -> image are native when Shrine main.js loads.
      When main.js is blocked (debounce / variant-selects are never defined, so the media-gallery constructor throws and no thumbnail ever gets a click handler) this file does the same job from the
      page's own DOM: thumbnail click, thumbnail strip arrows and main arrows (previous/next image), keyboard left/right, swipe, scroll -> active thumbnail, and swatch/pill -> that colour's image
      (variant JSON featured_media + the same alt filtering the native gallery uses). The check is made at event time (native() below), so nothing is handled twice when main.js loads.
      The thumbnail strip arrows, the main photo arrows and the keyboard keys always step to the previous/next IMAGE (native or not), because the native slider arrows lose count when photos are hidden or re-ordered by colour.
   B. CURATED slider PDPs (SoftClip, Bands, Wash Bag: splide-component, no media-gallery): the slider already works without main.js. Colour pick moves it to the first photo of that colour
      (alt text / file name match; no match = stays) and the slider starts on the photo of the product's selected (default) colour, e.g. Oat for SoftClip. Keys left/right use the slider arrows.
   Rollback: restore the R15c version of this file or remove the script tag in snippets/bf26z-sitewide.liquid. */
(function () {
  'use strict';
  if (window.__bf26zPdpGallery) return;
  window.__bf26zPdpGallery = 2;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function native() { return typeof window.debounce === 'function' && !!customElements.get('variant-selects'); }
  function shown(el) { return !!el && !el.classList.contains('hidden') && el.getClientRects().length > 0; }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s*-\s*sold out\s*$/, '').trim();
  }

  /* ---------- A. native media-gallery helpers ---------- */
  function slidesOf(mg) { return $$('.product__media-item', mg).filter(shown); }
  function listOf(mg) { return $('.product__media-list', mg); }
  function thumbFor(mg, id) { return $('.thumbnail-list__item[data-target="' + id + '"]', mg); }

  function reveal(ul, el) {
    if (!ul || !el) return;
    var lr = ul.getBoundingClientRect(), er = el.getBoundingClientRect();
    var vertical = ul.scrollHeight > ul.clientHeight + 4 && ul.scrollWidth <= ul.clientWidth + 4;
    if (vertical) {
      if (er.top < lr.top || er.bottom > lr.bottom) ul.scrollTo({ top: ul.scrollTop + er.top - lr.top - (lr.height - er.height) / 2 });
    } else if (er.left < lr.left || er.right > lr.right) {
      ul.scrollTo({ left: ul.scrollLeft + er.left - lr.left - (lr.width - er.width) / 2 });
    }
  }
  function setThumb(mg, id) {
    $$('.thumbnail-list__item button', mg).forEach(function (b) { b.removeAttribute('aria-current'); });
    var t = thumbFor(mg, id);
    if (!t) return;
    var b = $('button', t);
    if (b) b.setAttribute('aria-current', 'true');
    reveal(t.parentElement, t);
    var dots = $$('.slider-counter__link', mg).filter(shown);
    var slides = slidesOf(mg), i = -1;
    slides.forEach(function (s, k) { if (s.dataset.mediaId === id) i = k; });
    dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    var cur = $('.slider-counter--current', mg);
    if (cur && i > -1) cur.textContent = String(i + 1);
  }
  function pauseOthers(mg, keep) {
    $$('video', mg).forEach(function (v) { if (!keep || !keep.contains(v)) { try { v.pause(); } catch (e) {} } });
  }
  function setActive(mg, slide, o) {
    o = o || {};
    if (!slide) return;
    $$('.product__media-item.is-active', mg).forEach(function (s) { s.classList.remove('is-active'); });
    slide.classList.add('is-active');
    if (!o.fromScroll) {
      var list = slide.parentElement;
      var lr = list.getBoundingClientRect(), sr = slide.getBoundingClientRect();
      mg.__bf26zLock = Date.now() + 900; /* our own scroll: do not read it back as a swipe */
      list.scrollTo({ left: list.scrollLeft + sr.left - lr.left }); /* same call the native gallery makes (CSS decides smooth or instant) */
    }
    setThumb(mg, slide.dataset.mediaId);
    pauseOthers(mg, slide);
  }
  function currentSlide(mg) {
    var s = slidesOf(mg), list = listOf(mg);
    /* a swipe or the native slider moves the list without touching is-active, so read the position unless we just stepped ourselves */
    if (list && s.length && Date.now() > (mg.__bf26zStep || 0) && list.scrollWidth > list.clientWidth + 4) {
      var lr = list.getBoundingClientRect(), best = null, bd = 1e9;
      s.forEach(function (x) { var d = Math.abs(x.getBoundingClientRect().left - lr.left); if (d < bd) { bd = d; best = x; } });
      if (best) return best;
    }
    for (var i = 0; i < s.length; i++) if (s[i].classList.contains('is-active')) return s[i];
    return s[0] || null;
  }
  function step(mg, dir) {
    var s = slidesOf(mg);
    if (s.length < 2) return;
    var cur = currentSlide(mg), i = s.indexOf(cur);
    mg.__bf26zStep = Date.now() + 1200;
    if (i < 0) i = 0;
    var to = s[(i + dir + s.length) % s.length];
    setActive(mg, to); /* same result native or not; the native setActiveMedia would also scroll the page when the thumbnail strip is hidden (mobile) */
    if (native() && typeof mg.playActiveMedia === 'function') { try { mg.playActiveMedia(to); } catch (e) {} }
  }

  /* scroll / swipe -> active slide + thumbnail (only when the native gallery is not running) */
  function syncFromScroll(mg, list) {
    var lr = list.getBoundingClientRect(), best = null, bd = 1e9;
    slidesOf(mg).forEach(function (s) {
      var d = Math.abs(s.getBoundingClientRect().left - lr.left);
      if (d < bd) { bd = d; best = s; }
    });
    if (best && !best.classList.contains('is-active')) setActive(mg, best, { fromScroll: true });
  }
  function bindGallery(mg) {
    if (mg.__bf26z) return;
    mg.__bf26z = 1;
    /* the thumbnail strip arrows step to the previous/next image, so they must never be greyed out by the strip's own scroll state */
    $$('[id^="GalleryThumbnails"] .slider-button', mg).forEach(function (b) {
      b.removeAttribute('disabled');
      new MutationObserver(function () { if (b.hasAttribute('disabled')) b.removeAttribute('disabled'); }).observe(b, { attributes: true, attributeFilter: ['disabled'] });
    });
    var list = listOf(mg), t;
    if (list) {
      list.addEventListener('scroll', function () {
        if (native()) return;
        clearTimeout(t);
        t = setTimeout(function () { syncFromScroll(mg, list); }, Math.max(120, (mg.__bf26zLock || 0) - Date.now() + 40));
      }, { passive: true });
      /* touch swipe for layouts where the list is not scrollable */
      var x0 = null, y0 = 0;
      list.addEventListener('touchstart', function (e) { var p = e.touches[0]; x0 = p.clientX; y0 = p.clientY; }, { passive: true });
      list.addEventListener('touchend', function (e) {
        if (x0 === null || native()) { x0 = null; return; }
        var p = e.changedTouches[0], dx = p.clientX - x0, dy = p.clientY - y0;
        x0 = null;
        if (list.scrollWidth > list.clientWidth + 4) return; /* scrollable: the browser swipes it and the scroll handler syncs */
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(mg, dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  }
  function bindAll() { $$('media-gallery').forEach(bindGallery); }

  /* variant -> image (fallback only) */
  function pickVariant(vs) {
    var js = $('script[type="application/json"]', vs), data;
    if (!js) return null;
    try { data = JSON.parse(js.textContent); } catch (e) { return null; }
    var sel = [], seen = {};
    $$('input[type=radio], select', vs).forEach(function (el) {
      if (el.tagName === 'SELECT') { sel.push(el.value); return; }
      if (seen[el.name]) return;
      seen[el.name] = 1;
      var on = $$('input[type=radio]', vs).filter(function (r) { return r.name === el.name && r.checked; })[0];
      sel.push(on ? on.value : null);
    });
    var best = null;
    data.forEach(function (v) {
      if (best) return;
      var ok = sel.length > 0;
      sel.forEach(function (val, i) { if (val === null || v.options[i] !== val) ok = false; });
      if (ok) best = v;
    });
    return best;
  }
  function applyVariant(mg, v) {
    var opt = mg.dataset.filteringOption;
    if (opt && v[opt] != null) {
      $$('.product__media-item, .thumbnail-list__item, .slider-counter__link', mg).forEach(function (el) {
        var a = norm(el.dataset.alt);
        if (a === norm(v[opt]) || a === 'always_display') el.classList.remove('hidden'); else el.classList.add('hidden');
      });
      ['GalleryViewer', 'GalleryThumbnails'].forEach(function (p) {
        var c = $('[id^="' + p + '"]', mg);
        try { if (c && c.initPages) c.initPages(); if (c && c.update) c.update(); } catch (e) {}
      });
    }
    var id = v.featured_media && v.featured_media.id, hit = null;
    if (id) $$('.product__media-item', mg).forEach(function (s) { if (!hit && !s.classList.contains('hidden') && s.dataset.mediaId && s.dataset.mediaId.slice(-(String(id).length + 1)) === '-' + id) hit = s; });
    if (hit && mg.dataset.disablePrepend !== 'true') {
      /* same as the native gallery: the chosen colour's photo (and thumbnail) moves to the front, which is also what un-hides it when variant photos are hidden */
      var tt = thumbFor(mg, hit.dataset.mediaId), vw = $('[id^="GalleryViewer"]', mg);
      hit.parentElement.prepend(hit);
      if (tt) tt.parentElement.prepend(tt);
      try { if (vw && vw.resetPages) vw.resetPages(); } catch (e) {}
    }
    setActive(mg, hit || slidesOf(mg)[0]);
  }

  /* ---------- B. curated splide slider helpers ---------- */
  function wrap() { return $('.product__media-wrapper'); }
  function curated() {
    var w = wrap();
    if (!w || $('media-gallery', w)) return null;
    return $('splide-component', w);
  }
  function hay(img) {
    return norm((img.getAttribute('alt') || '') + ' ' + (img.getAttribute('src') || '') + ' ' + (img.getAttribute('data-src') || '') + ' ' + (img.getAttribute('srcset') || ''));
  }
  var KEY = { rose: ['rose', 'pink'], pink: ['pink', 'rose'], oat: ['oat', 'tan', 'caramel'], white: ['white', 'cream'], black: ['black'], mint: ['mint'], blue: ['blue'], purple: ['purple'], sunset: ['sunset'], grey: ['grey', 'gray'], green: ['green'] };
  function syncColour(value, instant) {
    var sc = curated();
    if (!sc) return;
    var c = norm(value);
    if (!c) return;
    var words = KEY[c] || [c];
    var slides = $$('.splide__slide:not(.splide__slide--clone)', sc), hit = -1;
    for (var pass = 0; pass < 2 && hit < 0; pass++) { /* alt text first, then alt + file name; the colour's own name before its aliases */
      for (var k = 0; k < words.length && hit < 0; k++) {
        var re = new RegExp('\\b' + words[k] + '\\b');
        for (var i = 0; i < slides.length; i++) {
          var im = $('img', slides[i]);
          if (im && re.test(pass ? hay(im) : norm(im.getAttribute('alt')))) { hit = i; break; }
        }
      }
    }
    if (hit < 0) return;
    var dots = $$('.splide__pagination__page', sc);
    if (!dots[hit] || dots[hit].classList.contains('is-active')) return;
    var list = $('.splide__list', sc), prev;
    if (instant && list) { prev = list.style.transition; list.style.transition = 'none'; }
    dots[hit].click();
    if (instant && list) setTimeout(function () { list.style.transition = prev || ''; }, 60);
  }
  function checkedColour() {
    var w = $('variant-selects');
    if (!w) return '';
    var r = $$('input[type=radio]', w).filter(function (x) { return x.checked && /colou?r/i.test(x.name); })[0];
    return r ? r.value : '';
  }
  function initCurated() {
    var tries = 0;
    (function wait() {
      var sc = curated();
      if (!sc) return;
      if ($('.splide__pagination__page', sc)) { syncColour(checkedColour(), true); return; }
      if (++tries < 30) setTimeout(wait, 150);
    })();
  }

  /* ---------- events ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var vs = t.closest('variant-selects');
    if (!vs || !t.closest('product-info')) return;
    if (curated()) {
      var v = t.value;
      setTimeout(function () { syncColour(v); }, 30);
      return;
    }
    var mg = $('media-gallery');
    if (!mg) return;
    var variant = pickVariant(vs);
    if (!variant) return;
    if (native()) {
      /* r55 (16 Oct 2026): Shrine's own handler stops when the colour has no variant image (no featured_media), so the gallery kept the previous colour's photos
         (RKKN Set Oat). Filter that colour here, after Shrine has run; colours with a variant image stay native. */
      if (!variant.featured_media && mg.dataset.filteringOption) setTimeout(function () { applyVariant(mg, variant); }, 60);
      return;
    }
    applyVariant(mg, variant);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var mg = t.closest('media-gallery');
    if (!mg) return;
    var item = t.closest('.thumbnail-list__item[data-target]');
    if (item) {
      if (native()) return;
      e.preventDefault();
      setActive(mg, $('.product__media-item[data-media-id="' + item.dataset.target + '"]', mg));
      return;
    }
    var btn = t.closest('button.slider-button, button.slider-button--prev, button.slider-button--next');
    if (!btn) return;
    var dir = btn.name === 'previous' ? -1 : (btn.name === 'next' ? 1 : 0);
    if (!dir) return;
    e.preventDefault();
    e.stopPropagation();
    step(mg, dir);
  }, true);

  var activeWrap = null;
  function setActiveWrap(e) {
    var t = e.target;
    activeWrap = t && t.closest ? t.closest('.product__media-wrapper') : null;
  }
  document.addEventListener('pointerdown', setActiveWrap, true);
  document.addEventListener('focusin', setActiveWrap, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) return;
    var t = e.target;
    if (t && (/^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName) || t.isContentEditable)) return;
    if (document.body.classList.contains('overflow-hidden')) return;
    var w = activeWrap && document.contains(activeWrap) ? activeWrap : null;
    if (!w && (t === document.body || t === document.documentElement || !t)) {
      var cand = wrap();
      if (cand) { var r = cand.getBoundingClientRect(); if (r.bottom > 0 && r.top < window.innerHeight) w = cand; }
    }
    if (!w) return;
    var dir = e.key === 'ArrowRight' ? 1 : -1, mg = $('media-gallery', w);
    if (mg) { e.preventDefault(); step(mg, dir); return; }
    var sc = $('splide-component', w), a = sc && $('.splide__arrow--' + (dir > 0 ? 'next' : 'prev'), sc);
    if (a) { e.preventDefault(); a.click(); }
  });

  /* the curated slider's own previous/next arrows are never refreshed after their first state (previous stays greyed out once you move on), so keep both usable */
  function unlockSplideArrows() {
    var w = wrap();
    if (!w || $('media-gallery', w)) return;
    function free(el) { if (el && el.hasAttribute && el.hasAttribute('disabled') && el.classList.contains('splide__arrow')) el.removeAttribute('disabled'); }
    $$('.splide__arrow', w).forEach(free);
    if (w.__bf26zArrows) return;
    w.__bf26zArrows = 1;
    new MutationObserver(function (list) { list.forEach(function (m) { free(m.target); }); }).observe(w, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
    var tries = 0;
    (function again() { $$('.splide__arrow', w).forEach(free); if (++tries < 20) setTimeout(again, 250); })();
  }

  function init() { bindAll(); initCurated(); unlockSplideArrows(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Lazy lookahead (11 Oct 2026). Lazy images inside the horizontal gallery scroller (and its thumbnail strip) only start loading once they are on screen, which shows blank frames when swiping.
   These observers flip loading to eager a few slides BEFORE an image is reached (3 viewport widths each side in the scrollers, 2.5 screens above and below for the rest of the page).
   Hidden slides (display none, other colours) never intersect, so they stay lazy until a colour change shows them; the observers stay attached to them, so no rescan is needed for that,
   and a rescan on variant change / DOM change picks up any image that was swapped in.
   Rollback: restore assets/bf26z-pdp-gallery-bak-20261011-lazy.js */
(function () {
  'use strict';
  if (window.__bf26zLazyAhead) return;
  window.__bf26zLazyAhead = 1;
  if (typeof IntersectionObserver !== 'function' || typeof WeakSet !== 'function' || typeof WeakMap !== 'function') return;
  var seen = new WeakSet(), byRoot = new WeakMap(), pageIO = null, pending = 0;
  var LISTS = '.product__media-list, .thumbnail-list';

  function make(root, margin) {
    return new IntersectionObserver(function (entries, io) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        if (en.target.getAttribute('loading') === 'lazy') en.target.setAttribute('loading', 'eager');
        io.unobserve(en.target);
      });
    }, { root: root, rootMargin: margin });
  }
  function watchList(list) {
    var io = byRoot.get(list), imgs = list.querySelectorAll('img[loading="lazy"]'), i;
    if (!io) { io = make(list, '0px 300% 0px 300%'); byRoot.set(list, io); }
    for (i = 0; i < imgs.length; i++) {
      if (seen.has(imgs[i])) continue;
      seen.add(imgs[i]);
      io.observe(imgs[i]);
    }
  }
  function scan() {
    var lists = document.querySelectorAll(LISTS), imgs, i;
    for (i = 0; i < lists.length; i++) watchList(lists[i]);
    imgs = document.querySelectorAll('main img[loading="lazy"]');
    for (i = 0; i < imgs.length; i++) {
      if (seen.has(imgs[i]) || imgs[i].closest(LISTS)) continue;
      if (!pageIO) pageIO = make(null, '250% 0px 250% 0px');
      seen.add(imgs[i]);
      pageIO.observe(imgs[i]);
    }
  }
  function soon() {
    if (pending) return;
    pending = requestAnimationFrame(function () { pending = 0; try { scan(); } catch (e) {} });
  }
  function boot() {
    try { scan(); } catch (e) {}
    var host = document.querySelector('main') || document.body;
    if (host && typeof MutationObserver === 'function') new MutationObserver(soon).observe(host, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects')) { soon(); setTimeout(soon, 250); }
    }, true);
    window.addEventListener('load', soon);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
